import { useState, useMemo, useEffect } from 'react'
import './claimlanding.css'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import ClaimStatusList from './ClaimStatusList'

const steps = [
  { id: 1, label: 'Claim Intimated', link: '/claim-intimated' },
  { id: 2, label: 'Surveyor Appointed', link: '/surveyor-appointed' },
  { id: 3, label: 'Survey Completion', link: '/completisurvey-on' },
  { id: 4, label: 'Work Approval', link: '/work-approval' },
  { id: 5, label: 'Under Repair Inspection', link: '/repair-inspection' },
  { id: 6, label: 'Re Inspection', link: '/re-inspection' },
  { id: 7, label: 'Pre-Invoice/Invoice', link: '/pre-invoice' },
  { id: 8, label: 'Delivery Order', link: '/delivery-order' },
  { id: 9, label: 'Payment', link: '/payment' }
]

const ProgressSteps = ({ currentStep }) => {
  const handleStepClick = step => {
    window.location.href = step.link
  }

  return (
    <div className='progress-scroll-wrapper'>
      <div className='progress-containerr'>
        {steps.map((step, index) => (
          <div className='step-wrapper' key={index}>
            {index > 0 && (
              <div
                className={`step-line ${
                  index < currentStep ? 'completed-line' : 'inactive-line'
                }`}
              ></div>
            )}

            <div
              className={`step-circle ${
                index < currentStep ? 'completed' : 'inactive'
              }`}
              title={step.label}
            >
              ✓
            </div>
            <div className={`step-label-wrapper`}>
              <div
                className={`step-label ${
                  index < currentStep ? 'completed-label' : 'inactive-label'
                }`}
              >
                {step.label}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const ClaimDetails = ({
  policyNumber,
  date,
  vehicle,
  model,
  varient,
  currentStep,
  totalSteps
}) => {
  const { claimNumber } = useParams()

  const progressPercentage = (currentStep / totalSteps) * 100
  const progress = `${currentStep}/${totalSteps}`
  const [formData, setFormData] = useState({
    claim_number: '',
    email_id: '',
    phone_number: '',
    created_at: '',
    date: '',
    policy_number: '',
    model: '',
    vehicle_number: ''
  })

  useEffect(() => {
    const fetchClaimDetails = async () => {
      try {
        const res = await axios.post('/process_data/claim-details', {
          claimNumber
        })
        console.log('391', res.data)
        setFormData(res.data)
      } catch (err) {
        console.error('Error fetching claim details:', err)
      }
    }

    if (claimNumber) {
      fetchClaimDetails()
    }
  }, [claimNumber])

  return (
    <div className='claim-container'>
      <h4 className='claim-details-title'>Claim Details</h4>
      <div className='claim-box'>
        <div className='progress-indicator'>
          <svg viewBox='0 0 36 36'>
            <path
              d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
              fill='none'
              stroke='#e6e6e6'
              strokeWidth='3'
            />
            <path
              d='M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831'
              fill='none'
              stroke='#ff1493'
              strokeWidth='3'
              strokeDasharray={`${progressPercentage}, 100`}
            />
          </svg>
          <div className='progress-texts'>{progress}</div>
        </div>

        <div className='details-grid'>
          <p className='claim-number'>
            <strong style={{ fontWeight: '700' }}>{claimNumber}</strong>
          </p>

          <p>
            {currentStep} of {totalSteps} steps are completed
          </p>

          <p>
            <span style={{ fontWeight: 'bold' }}>Policy: </span>
            {formData.policy_number?.toUpperCase()}
          </p>

          <p>
            <span style={{ fontWeight: 'bold' }}>Vehicle: </span>
            {formData.vehicle_number?.toUpperCase()}
          </p>

          <p>
            <span style={{ fontWeight: 'bold' }}>Model: </span>
            {formData.model?.toUpperCase()}
          </p>
        </div>
      </div>
    </div>
  )
}

const ClaimTrackingUI = () => {
  const { claimNumber } = useParams()
  const navigate = useNavigate()
  useEffect(() => {
    const handlePopState = () => {
      navigate(`/home`, { replace: true })
    }

    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [navigate, claimNumber])
  const allClaims = useMemo(() => {
    return JSON.parse(localStorage.getItem('claimsData')) || []
  }, [])

  const claimFromState = useMemo(() => {
    return allClaims.find(claim => claim.claimNumber === claimNumber)
  }, [allClaims, claimNumber])

  const [claimDetails, setClaimDetails] = useState({})
  const [progressData, setProgressData] = useState(2)
  const [currentStep, setCurrentStep] = useState(2)

  const totalSteps = 9

  useEffect(() => {
    if (claimFromState) {
      setClaimDetails(claimFromState)
    }
  }, [claimFromState])

  useEffect(() => {
    const fetchProgress = async () => {
      if (claimNumber) {
        try {
          const res = await axios.post(
            `/process_data/claim_progress/${claimNumber}`
          )
          setProgressData(res.data)
        } catch (err) {
          console.error('Error fetching claim progress:', err)
        }
      }
    }
    fetchProgress()
  }, [claimNumber])

  useEffect(() => {
    let step = 2

    if (progressData.survey_doc === 1 && progressData.survey_upload === 1)
      step = 3
    if (step === 3 && progressData.work_app_update === 1) step = 4
    if (
      step === 4 &&
      (progressData.pre_repair_doc === 1 ||
        progressData.pre_repair_upload === 1)
    )
      step = 5
    if (
      step === 5 &&
      (progressData.post_repair_doc === 1 ||
        progressData.post_repair_upload === 1)
    )
      step = 6
    if (
      step === 6 &&
      (progressData.invoice === 1 || progressData.pre_invoice === 1)
    )
      step = 7
    if (step === 7 && progressData.delivery === 1) step = 9

    setCurrentStep(step)
  }, [progressData])

  return (
    <div className='claim-tracking-container'>
      <ProgressSteps currentStep={currentStep} />
      <div className='claims-wrapper-landing'>
        <ClaimDetails
          {...claimDetails}
          currentStep={currentStep}
          totalSteps={totalSteps}
        />
        <ClaimStatusList currentStep={currentStep} />
      </div>
    </div>
  )
}

export default ClaimTrackingUI
